import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

class WhiteLabelController {
  static getWhiteLabels() {
    return new Promise((resolve, reject) => {
      axios
        .get("/main-admin/white-label/get-all")
        .then((res) => {
          console.log(res.data, "@white labels");
          if (res.data.success) {
            resolve(res.data.data);
          } else {
            reject(res.data.message);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static updateWhiteLabelStatus(id, status) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/main-admin/white-label/update-status/${id}`, { status })
        .then((res) => {
          if (res.data.success) {
            resolve(res.data.data);
          } else {
            reject(res.data.message);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  //
  static downloadWhiteLabelAssets(id, name) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/main-admin/white-label/download-assets/${id}`, {
          responseType: "blob",
        })
        .then((res) => {
          const contentDisposition = res.headers["content-disposition"];
          let fileName = `${name}.zip`;

          if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/);
            if (match && match[1]) {
              fileName = match[1];
            }
          }

          const blob = new Blob([res.data], {
            type: res.headers["content-type"],
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          resolve(true);
        })
        .catch(reject);
    });
  }
}

export default WhiteLabelController;

export const useWhiteLabels = () => {
  const [whiteLabels, setWhiteLabels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const handleGetWhiteLabels = () => {
    setLoading(true);
    WhiteLabelController.getWhiteLabels()
      .then((res) => {
        setWhiteLabels(res?.requests);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleUpdateWhiteLabelStatus = (id, status) => {
    WhiteLabelController.updateWhiteLabelStatus(id, status)
      .then((res) => {
        setWhiteLabels(
          whiteLabels.map((whiteLabel) =>
            whiteLabel._id === res?.request?._id
              ? { ...whiteLabel, status: res?.request?.status }
              : whiteLabel
          )
        );
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setStatusLoading(null);
      });
  };

  const handleDownloadWhiteLabelAssets = (id, name) => {
    setDownloadLoading(true);
    WhiteLabelController.downloadWhiteLabelAssets(id, name)
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        toast.error(err);
      })
      .finally(() => {
        setDownloadLoading(false);
      });
  };

  useEffect(() => {
    handleGetWhiteLabels();
  }, []);

  return {
    whiteLabels,
    loading,
    statusLoading,
    handleUpdateWhiteLabelStatus,
    setStatusLoading,
    downloadLoading,
    handleDownloadWhiteLabelAssets,
    setDownloadLoading,
  };
};
